import { StateCreator } from 'zustand';

import { AuthStatusSliceProps } from '@/shared/store/auth/authSlice.types.ts';

export const createAuthStatusSlice: StateCreator<AuthStatusSliceProps> = (set, _) => ({
  isAuthorized: false,
  setAuthorized: (value: boolean) => set({ isAuthorized: value }),
});
